module.exports = __webpack_public_path__ + "img/banner-2.59a9e3c0.svg";